import { Observable, of } from "rxjs";
import { Producer } from '../../models/producer.model';

export class StubProducerService {
    getProducersInfoByCurrentUser(): Observable<any[]> {
        return of();
    }

    producerByProducerCode(): Observable<any> {
        return of();
    }

    getByUserID() { }

    get currentProducerValue(): Producer { return new Producer(); }

    getFormattedProducerCode() { }

    getProducerHigherRole() { }
}
